var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 64,
    viewBox: "0 0 68 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_11_472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2444 4C45.7639 4 46.2462 4.25046 46.5458 4.66392L46.6626 4.85084L55.2484 20.9496L55.3403 21.169L55.3652 21.25L55.4016 21.4156L55.4215 21.6042L55.417 21.8172L55.423 21.6786C55.423 21.9038 55.3767 22.1183 55.2929 22.3131L55.2312 22.4408L55.1442 22.5835L55.0313 22.7303L30.9942 50.5101C30.7797 50.7981 30.4859 50.9879 30.1669 51.0792L30.0426 51.1094L29.8339 51.1384L29.7083 51.1429L29.4927 51.1283L29.3104 51.0938L29.089 51.0211L29.0339 50.995C28.8404 50.9095 28.6626 50.782 28.5139 50.6146L4.36026 22.6992L4.22716 22.5115L4.1245 22.312L4.05019 22.0992L4.0006 21.8183L4 21.5453L4.03184 21.3338L4.05239 21.2498L4.12504 21.0439L4.18362 20.9224L12.755 4.85084C12.9994 4.39259 13.4474 4.08486 13.9532 4.01509L14.1731 4H45.2444ZM38.0787 23.2857H21.3323L29.7109 45.0571L38.0787 23.2857ZM17.891 23.2857H9.11382L24.913 41.5386L17.891 23.2857ZM50.2973 23.2857H41.5266L34.513 41.5236L50.2973 23.2857ZM21.1887 7.21214H15.1353L8.27596 20.0714H17.7581L21.1887 7.21214ZM34.9009 7.21214H24.5145L21.0838 20.0714H38.3294L34.9009 7.21214ZM44.2802 7.21214H38.2266L41.6573 20.0714H51.1352L44.2802 7.21214Z",
    fill: "#EBEFF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_11_472",
    x: 0,
    y: 0,
    width: 67.423,
    height: 63.1429,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11_472"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11_472",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_11_472"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.ba3a75ff5e24c678484e63a57ea7e312.svg";
export { ForwardRef as ReactComponent };